var exports = {
  "E": "Text__TXgZM5",
  "a": "Box__U-Wwl5",
};

module.exports = exports;
